import { ISpecializedCombo, useCombo, CreateOptionsParams, AfterLoadEventHandler } from "@hooks/useCombo";
import { MenuItem } from "@material-ui/core";
import { useUsuarioService } from "@services/UsuarioService";
import { TDate } from "@utils/TypeHelpers";
import React from "react";
import { EnumUsuarioStatus } from "./UsuarioStatus";

export interface IUsuario {
    usuarioId: number

    usuarioStatusId: EnumUsuarioStatus
    nomeUsuario: string
    senha: string,
    nome: string
    ultimoLogin?: TDate
    
    usuarioStatusNome: string
}

export type IComboUsuario = ISpecializedCombo<IUsuario> & {
    loadInternos: (afterLoad?: AfterLoadEventHandler<IUsuario> | undefined) => void    
}

export function useUsuarioCombo (initialValue?: number) : IComboUsuario {
    const combo = useCombo<IUsuario>({
        value: initialValue
    });

    const usuarioService = useUsuarioService();

    const createOptions = React.useCallback((params?: CreateOptionsParams) => {
        return combo.set.map((usuario, index) => {
            return <MenuItem key={index} value={usuario.usuarioId}>{params?.prefix}{usuario.nome}{params?.sufix}</MenuItem>
        });
    }, [combo.set]);

    const loadInternos = React.useCallback((afterLoad?: AfterLoadEventHandler<IUsuario>) => {
        combo.load(usuarioService.listarInternos, afterLoad)
    }, [combo, usuarioService.listarInternos]);

    const loadOptions = React.useCallback((afterLoad?: AfterLoadEventHandler<IUsuario>) => {
        throw new Error("Not implemented");
    }, []);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions, loadInternos
    }), [combo, createOptions, loadOptions, loadInternos]);
}

